import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;
const facebookPage = 'https://www.facebook.com/profile.php?id=100066332889118';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=400&height=560&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const SocialFeed = () => (
  <section className="lab-social-section">
    <div className="lab-social-inner">
      <Title level={2} className="lab-social-title">Social Feed</Title>
      <Divider className="ncgsa-divider" />

      <div className="lab-facebook-frame-wrap">
        <iframe
          title="GIS and Space Applications in Geosciences Lab Facebook feed"
          src={facebookEmbed}
          className="lab-facebook-frame"
          width="400"
          height="560"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>

      <a
        href={facebookPage}
        target="_blank"
        rel="noreferrer"
        className="lab-facebook-fallback"
      >
        View G-SAGL on Facebook
      </a>
    </div>
  </section>
);

export default SocialFeed;
